<div class="m-6 flex flex-col gap-6">
  <div class="flex items-center justify-between px-2 py-4">
    <h1>{{ "prescription.label.guarantee" | translate }}</h1>
    <button mat-dialog-close>
      <mat-icon
        aria-hidden="false"
        aria-label="Close icon"
        fontIcon="close"
      ></mat-icon>
    </button>
  </div>
  <form
    class="flex flex-col"
    [formGroup]="prescriptionGuaranteeForm"
  >
    <div class="flex flex-col gap-4">
      <div class="flex w-full items-start justify-between">
        <mat-radio-group
          aria-label="Select an option"
          formControlName="approve"
          color="primary"
          class="flex flex-col gap-4"
        >
          <mat-radio-button [value]="true">{{ "buttons.prescription.approveGuarantee" | translate }}</mat-radio-button>
          <mat-radio-button [value]="false">{{ "buttons.prescription.declineGuarantee" | translate }}</mat-radio-button>
        </mat-radio-group>

        @if (!!franchise() || franchise() === 0) {
          <div class="mt-2 flex items-center gap-2">
            <shared-info-badge
              [color]="badgeColors.Blue"
              [withBorder]="true"
              [fontSize]="'text-md'"
              [text]="'prescription.label.franchise' | translate: { percentage: franchise() }"
            ></shared-info-badge>
            <mat-icon
              class="text-info-600"
              [fontIcon]="'info_outline'"
              [matTooltip]="getFranchiseLabel(franchise())"
            ></mat-icon>
          </div>
        }
      </div>

      @if (prescriptionGuaranteeForm.get("approve").value === true) {
        <mat-form-field>
          <mat-label>{{ "prescription.label.editReason" | translate }}</mat-label>
          <input
            matInput
            formControlName="declineReason"
          />
        </mat-form-field>
      } @else {
        <mat-form-field>
          <mat-label>{{ "prescription.label.declineReason" | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="declineReason"
            [matAutocomplete]="declineReasonAutocomplete"
          />
          <mat-autocomplete #declineReasonAutocomplete="matAutocomplete">
            @for (reason of filteredDeclineReasons(); track reason) {
              <mat-option [value]="reason">
                {{ reason }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }
    </div>
    <div class="flex h-[6.75rem] flex-col">
      @if (prescriptionGuaranteeForm.controls["approve"].value === true) {
        <div class="mb-4 flex items-center gap-4">
          <mat-checkbox formControlName="completedInAppointment">{{ "prescription.label.completed" | translate }}</mat-checkbox>
        </div>

        @if (prescriptionGuaranteeForm.controls["completedInAppointment"].value === true) {
          <mat-form-field class="w-full">
            <mat-label>{{ "prescription.label.completionReason" | translate }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="completionReason"
            />
            @if (prescriptionGuaranteeForm.controls["completionReason"]?.invalid) {
              <mat-error class="text-sm text-red-error-dark">{{ "validation.error.required" | translate }}</mat-error>
            }
          </mat-form-field>
        }
      }
    </div>

    <div class="flex items-center justify-end gap-4">
      <button
        class="btn text-gray-2 underline hover:bg-gray-4"
        [type]="'button'"
        (click)="onClose()"
      >
        {{ "buttons.return" | translate }}
      </button>
      <button
        class="btn btn-primary shadow duration-75 hover:-translate-y-0.5 disabled:bg-gray-2"
        [type]="'button'"
        [disabled]="!prescriptionGuaranteeForm.valid"
        [mat-dialog-close]="prescriptionGuaranteeForm.value"
        (click)="onSubmit()"
      >
        {{ "buttons.confirm" | translate }}
      </button>
    </div>
  </form>
</div>
